import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 70.3 70.3"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M35.15 0C54.56 0 70.3 15.74 70.3 35.15S54.56 70.3 35.15 70.3 0 54.57 0 35.15 15.74 0 35.15 0",
      style: {"fill":"#e31d1a"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M56.75 38.32s-1.49-3.23-4.45-4.89c-2.96-1.66-7-1.79-7-1.79s-9.61 5.02-14.6 9.86-7.44 10.12-7.44 10.12-2.75-2.1-2.71-3.11c.04-1.01 4.77-6.98 9.32-10.44 4.55-3.47 11.42-6.32 11.42-6.32s-8.35.54-17.35 5.6c-9 5.06-16.4 13.55-16.4 13.55s3.4-6.97 14.38-13.91 19.25-7.69 25.25-7.09c9.36.94 9.59 8.42 9.59 8.42ZM45.18 27.03c.52-.31-.38-1.71-1.51-1.76-1.13-.05-2.61.6-2.61.6s3.59 1.47 4.12 1.16Zm8.35-2.87c.57-.21-.07-1.75-1.18-2-1.1-.25-2.67.14-2.67.14s3.28 2.07 3.85 1.85Zm-1.13 5.25s-.64-1.42-2.37-2.52c-1.74-1.1-3.42-1.63-3.42-1.63l-.28-2.15s-9.41-2.62-19.77.26-18.04 9.2-18.04 9.2 7.05-8.38 20.94-12.77c13.89-4.4 25.43-.75 25.92-.11.49.64.66 2.41 1.31 2.56.65.15 3.09.37 4.49 2.34 1.4 1.96.67 4.9.67 4.9s-2.37-1.44-5.12-1.25-4.32 1.18-4.32 1.18",
      style: {"fill":"#fff","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "S3-logo"}) } }